export const handleNavigate = () => {
  if (
    window.location.pathname != "/" ||
    window.location.pathname != "/not-found"
  ) {
    localStorage.setItem("recentPage", window.location.pathname);
  }
};
